import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueGtag from 'vue-gtag'
import VueGtm from 'vue-gtm'
import VTooltip from 'v-tooltip'
import axiosInterceptors from '@/utils/axiosInterceptors'
import recaptcha from '@/utils/recaptcha'
import extended from '@/utils/extendedFieldValidations'
import '@/utils/globalFilters'

/*
 * TODO: This application should be upgraded to Vue v3 if/when time permits.
 * Vue v2 was used to keep this application consistent with Reservation System.
 */

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: window.config.GA_ID }
});

Vue.use(VueGtm, {
  id: window.config.GTM_ID,
  debug: true,
  trackOnNextTick: false,
});

Vue.use(recaptcha);

Vue.use(VTooltip, { defaultTrigger: 'hover focus click' })

axiosInterceptors();

// extended field validation rules for vee-validate
extended.alphaNum();
extended.fieldRequired();
extended.minDate();
extended.minMax();
extended.max();
extended.monthBetween();
extended.specialChars();
extended.validYear();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
